import { useEffect, useState } from "react";
import { AddIcon } from "../../../../../data/iconImage";
import { useAlert } from "../../../../../context/AlertContext";
import {
  deleteServiceRequest,
  getServiceRequest
} from "../../../../../commons/ServiceRequest";
import Table from "../../../../../components/Table";
import ButtonLink from "../../../../../components/ButtonLink";
import SearchFilter from "../../../../../components/SearchFilter";
import ButtonOptionSubmenu from "../../../../../components/ButtonOptionSubmenu";
import DocPrefixsService from "../../../../../services/docprefix.service";
import CardDisplayComponent from "../../../../../components/CardDisplayComponent";

export default function PrefixTab() {
  const { showAlert } = useAlert();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [searchValue, setSearchValue] = useState([]);
  const searchInput = [
    { name: "Com_Code", label: "รหัสบริษัท", minKeywordLength: 1 },
    { name: "Prefix_Code", label: "รหัสย่อ", minKeywordLength: 1 },
    { name: "Prefix_Name", label: "อักษรย่อ", minKeywordLength: 1 }
  ];
  const columns = [
    { name: "รหัสบริษัท", selector: (row) => row.Com_Code, sortable: true },
    {
      name: "ประเภทงาน",
      selector: (row) => row.JobType.Job_Type_Name,
      sortable: true,
      grow: 1.5
    },
    {
      name: "รหัสย่อ",
      selector: (row) => row.Prefix_Code,
      sortable: true,
      grow: 1.5
    },
    { name: "อักษรย่อ", selector: (row) => row.Prefix_Name, grow: 2 },
    { name: "ความหมาย", selector: (row) => row.Prefix_Des, grow: 2 },
    {
      name: "สถานะ",
      selector: (row) => (row.Prefix_Status ? "ใช้งาน" : "ไม่ใช้งาน")
    },
    {
      name: "",
      selector: (row) => (
        <ButtonOptionSubmenu
          data={row}
          editButton
          deleteButton
          onDeleteCallback={(event, { Id }) =>
            deleteServiceRequest({
              showAlert,
              setLoading,
              serviceRequest: DocPrefixsService.deleteDocPrefixs(Id, false),
              refreshRequest: DocPrefixsService.getAllDocPrefixs(),
              callback: (res) => setData(res)
            })
          }
        />
      ),
      right: true,
      width: "180px"
    }
  ];

  useEffect(() => {
    getServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: DocPrefixsService.getAllDocPrefixs(),
      callback: (res) => setData(res)
    });
  }, []);

  return (
    <>
      <CardDisplayComponent
        body={{
          element: (
            <SearchFilter
              data={data}
              inputField={searchInput}
              fieldClassName={{ actionButton: "w-auto py-2" }}
              searchCallback={(search) => setSearchValue(search)}
            />
          )
        }}
      />

      <CardDisplayComponent
        header={{
          className: "d-flex justify-content-between align-items-center",
          title: { text: "กำหนดอักษรนำหน้าเลขที่เอกสาร" },
          button: (
            <ButtonLink
              linkTo="create"
              buttonName="เพิ่มข้อมูล"
              buttonClass="py-2 px-3 rounded-pill"
              iconSrc={AddIcon}
              iconClass="me-2 mb-1"
              iconName="Add Icon"
            />
          )
        }}
        body={{
          element: (
            <Table
              data={data}
              column={columns}
              pending={loading}
              searchFilter={searchValue}
              pagination
            />
          )
        }}
      />
    </>
  );
}
